import styled from 'styled-components';

const U = {
  TableContainer: styled.div`
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 8px 0 28px;
      font-size: 16px;
  `,

  StyledTable: styled.table`
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      text-align: center;
      font-variant-numeric: tabular-nums;
      background: #ffffff;
      border: 1px solid #eceff3;
      border-radius: 14px;
      overflow: hidden;
      box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);

      th,
      td {
        border: none;
        border-bottom: 1px solid #f0f2f5;
        padding: 15px 12px;
      }

      thead th {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: -0.2px;
        color: #334155;
        background: #e8eef8;
        border-bottom: 1px solid #d5deea;
      }

      thead tr:first-child th {
        font-size: 15px;
        color: #1e293b;
        padding-top: 16px;
      }

      thead tr:first-child th:nth-child(2) {
        color: #3d5afe;
      }

      thead tr:first-child th:nth-child(3) {
        color: #1b7a4e;
      }

      thead tr:first-child th:nth-child(4) {
        color: #475569;
      }

      tbody th {
        font-size: 15px;
        font-weight: 600;
        color: #1f2937;
        text-align: left;
        padding-left: 18px;
        background: #fcfdff;
        white-space: nowrap;
      }

      tbody td {
        font-size: 16px;
        color: #374151;
      }

      tbody tr:last-child th,
      tbody tr:last-child td {
        background: #eef4ff;
        font-weight: 700;
        border-bottom: none;
      }

      tbody tr:hover th,
      tbody tr:hover td {
        background: #f5f8ff;
      }

      tbody tr:last-child:hover th,
      tbody tr:last-child:hover td {
        background: #e4edff;
      }
  `,

  VariationTD: styled.td`
      cursor: ${props => (props.value > 0 ? 'pointer' : 'default')};
  `,

  ChangeBadge: styled.span`
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 56px;
      padding: 5px 11px;
      border-radius: 999px;
      font-size: 15px;
      font-weight: 700;
      letter-spacing: -0.2px;
      color: ${props =>
        props.$value > 0 ? '#2563eb' : props.$value === 0 ? '#94a3b8' : '#e11d48'};
      background: ${props =>
        props.$value > 0 ? '#eff6ff' : props.$value === 0 ? '#f8fafc' : '#fff1f2'};
  `,
}

export default U;
